import Applet from '../../windows/Applet'
import Authentication from '../../windows/Authentication'
import CreateApplet from '../../windows/CreateApplet'
import CreateHub from '../../windows/CreateHub'
import Desk from '../../windows/Desk'
import Drive from '../../windows/Drive'
import EmailApplet from '../../windows/EmailApplet'
import Hub from '../../windows/Hub'
import MessengerPortal from '../../windows/MessengerPortal'
import Notebook from '../../windows/Notebook'
import Rooms from '../../windows/Rooms'
import Room from '../../windows/Rooms/Room'
import Search from '../../windows/Search'
import Settings from '../../windows/Settings'
import Test from '../../windows/Test'
import DashboardBuilder from '../../windows/DashboardBuilder'
// import Developers from '../../windows/Developers'
import Downloader from '../../windows/Downloader'
import AudioPlayer from '../../windows/AudioPlayer'
import DeskApplet from '../../windows/Applets/DeskApplet'
import YonnectWorld from '../views/yonnectWorld/YonnectWorld'
import MainCalendar from '../../windows/MainCalendar'
import Payment from '../../windows/Payment'
import DrivePortal from '../../windows/Applets/DrivePortal'
import RoomsPortal from '../../windows/Applets/RoomsPortal'
// import Connections from '../../windows/Connections'


const WindowsList = {
    authentication: Authentication,
    createhub: CreateHub,
    createapplet: CreateApplet,
    rooms: RoomsPortal,
    
    // room: Room,
    messenger: MessengerPortal,
    drive: DrivePortal,
    // notebook: Notebook,
    applet: Applet,
    hub: Hub,
    settings: Settings,
    search: Search,
    calendar: MainCalendar,
    email: EmailApplet,
    desk: Desk,
    // developers: Developers,
    // test: Test,
    yonnectworld: YonnectWorld,
    world: YonnectWorld,

    // connections:Connections,
    // dashboardbuilder: DashboardBuilder,
    downloader: Downloader,
    player: AudioPlayer,
    payment:Payment,

}

export default WindowsList